<svg
  width="18"
  height="10"
  viewBox="0 0 18 10"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1,5.3 L13,5.3 L13,2 L17,5.3 L13,8.6 L13,5.3"
    fill="none"
    stroke="black"
    stroke-width="1.7"
    stroke-linejoin="round"
    stroke-linecap="round"
  />
</svg>
